import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { CoreUIIconComponent } from './core-ui-icon/core-ui-icon.component';
import { CoreUIContextMenuComponent } from './core-ui-context-menu/core-ui-context-menu.component';
import { CoreUIActionMenuComponent } from './core-ui-action-menu/core-ui-action-menu.component';
import { CoreUIFileTypeIconComponent } from './file-type-icon/file-type-icon.component';

@NgModule({
  declarations: [
    CoreUIIconComponent,
    CoreUIContextMenuComponent,
    CoreUIActionMenuComponent,
    CoreUIFileTypeIconComponent,
  ],
  imports: [CommonModule, OverlayModule],
  exports: [
    CoreUIIconComponent,
    CoreUIContextMenuComponent,
    CoreUIActionMenuComponent,
    CoreUIFileTypeIconComponent,
  ],
})
export class CoreUIIconsModule {}
